import { TutorialsView } from "./TutorialsView";
import { useTutorialManifest } from "./useTutorialManifest";

export const Tutorials = () => {
  const { manifest, isLoading, isError } = useTutorialManifest();
  const tutorials = [...(manifest?.videos ?? [])].sort((a, b) => {
    const categoryComparison = a.category.localeCompare(b.category);
    if (categoryComparison !== 0) return categoryComparison;
    if (a.order !== b.order) return a.order - b.order;
    return a.title.localeCompare(b.title);
  });

  return <TutorialsView tutorials={tutorials} isLoading={isLoading} hasError={Boolean(isError)} />;
};
